import { create } from 'zustand';

type State = {
  isVisible: boolean;
};

type Action = {
    setIsVisiblePark: (isVisible: boolean) => void;
};

export const useModalParkStore = create<State & Action>(set => ({
  isVisible: false,
  setIsVisiblePark: isVisible => {
    set(() => ({
      isVisible,
    }));
  },
}));
